import { jsx as l } from "react/jsx-runtime";
const a = (h) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...h,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        d: "m49.333 11.744-.005 4.082H39.003l.536 2h9.786l-.006 4.25H38.877l.536 2h9.904l-.006 4.251H38.899l.536 2h9.873l-.006 4.338H32.85l3.036 11.183c.21.769.206 1.58-.007 2.348a4.442 4.442 0 0 1-3.823 3.215L27.71 35.186a6.274 6.274 0 0 0-4.088-4.34l-3.06-1.019V15.07h1.506c2.013 0 3.905-.849 5.19-2.329a3.003 3.003 0 0 1 2.269-1.035h19.75l-1.073-4H29.526c-2.03 0-3.957.88-5.288 2.412a2.807 2.807 0 0 1-1.728.92V8.342h-9.126a3.96 3.96 0 0 0-3.955 3.955v22.974c0 2.25 1.83 4.08 4.081 4.08h9.017l.036-4.63c.63.28 1.102.827 1.282 1.5l5.148 19.212h2.623a8.452 8.452 0 0 0 8.116-6.163 8.429 8.429 0 0 0 .015-4.47l-1.666-6.135h11.391a3.835 3.835 0 0 0 3.83-3.825l.033-24.168-4.002 1.072ZM18.561 35.056l-.003.296H13.51a.081.081 0 0 1-.081-.081V12.34h5.081v2.728h.05v19.987Z"
      }
    )
  }
);
export {
  a as ThumbsDown
};
